import React from 'react';
import { TimeEntry } from '../../types/time-entry';

interface WeeklyCalendarDayProps {
  date: Date;
  entries: TimeEntry[];
  dailyTotal: number;
  isToday: boolean;
  formatDate: (date: Date) => string;
  getProjectName: (projectId: string) => string;
  getCategoryName: (categoryId: string) => string;
}

const WeeklyCalendarDay: React.FC<WeeklyCalendarDayProps> = ({
  date,
  entries,
  dailyTotal,
  isToday,
  formatDate,
  getProjectName,
  getCategoryName,
}) => {
  return (
    <div
      className={`bg-white dark:bg-gray-800 border rounded-lg shadow-sm ${
        isToday ? 'border-primary-500 border-2' : 'border-gray-200 dark:border-gray-700'
      }`}
    >
      <div className="p-4">
        <div className="font-semibold mb-1 text-sm text-gray-900 dark:text-gray-100">
          {formatDate(date)}
          {isToday && (
            <span className="badge ml-2 text-xs bg-primary-100 dark:bg-primary-900 text-primary-800 dark:text-primary-200 px-2 py-1 rounded">
              Today
            </span>
          )}
        </div>
        <div className="text-2xl font-bold text-primary-600 dark:text-primary-400 mb-2">
          {dailyTotal.toFixed(1)}h
        </div>

        {entries.length === 0 ? (
          <div className="text-xs text-gray-400 dark:text-gray-500">
            No entries
          </div>
        ) : (
          <div className="text-xs flex flex-col gap-1">
            {entries.map(entry => {
              const isCategory = entry.category_id !== null;
              return (
                <div
                  key={entry.id}
                  className={`p-1 rounded-sm ${
                    isCategory 
                      ? 'bg-accent-100 dark:bg-accent-900/20 border-l-2 border-accent-500' 
                      : 'bg-gray-100 dark:bg-gray-700 border-l-2 border-primary-500'
                  }`}
                >
                  <div className="font-semibold text-gray-900 dark:text-gray-100">
                    {parseFloat(String(entry.hours)).toFixed(1)}h
                  </div>
                  <div className="text-gray-600 dark:text-gray-400 flex items-center gap-1">
                    {isCategory ? (
                      <>
                        <span className="text-xs">📋</span>
                        {getCategoryName(entry.category_id!)}
                      </>
                    ) : (
                      getProjectName(entry.project_id!)
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default WeeklyCalendarDay;
